<script lang="ts">
    import { ExclamationCircleOutline } from "flowbite-svelte-icons";
    import posthog from "posthog-js";
    import ColoredModal from "../colored/ColoredModal.svelte";
    import ColoredButton from "../colored/ColoredButton.svelte";

    let {isOpen = $bindable(), reset, close}: {
        isOpen: boolean,
        reset: () => void,
        close: () => void
    } = $props();

    function confirmReset() {
        posthog.capture('counter_reset');
        reset();
    }

</script>

<ColoredModal autoclose bind:open={isOpen} size="xs">
    <div class="text-center">
        <ExclamationCircleOutline class="mx-auto mb-4 w-12 h-12"/>
        <h3 class="mb-5 text-lg font-normal">Are you sure you want to reset the
            counter?</h3>
        <ColoredButton class="me-2" color="red" onclick={confirmReset}>Yes, I'm sure</ColoredButton>
        <ColoredButton color="teal" onclick={close}>No, cancel</ColoredButton>
    </div>
</ColoredModal>
